import { Landmark, ShieldCheck, Mountain, Building2, Rocket, MonitorSmartphone } from"lucide-react";
import { useTranslation } from"@/i18n/LanguageContext";

const industryIcons = [Landmark, ShieldCheck, Mountain, Building2, Rocket, MonitorSmartphone];
const colors = [
"",
"",
"",
"",
"",
"",
];

export function IndustriesSection() {
 const { t } = useTranslation();
 const items: { title: string; desc: string }[] = t("industries.items");

 return (
 <section id="industries" className="py-24 bg-background relative overflow-hidden">
 <div className="container relative z-10">
 <div className="text-center mb-16">
 <span className="inline-block text-sm font-semibold uppercase tracking-wider text-primary bg-primary/10 px-4 py-1.5 rounded-full mb-4">
 {t("industries.badge")}
 </span>
  <h2 className="text-3xl md:text-5xl font-bold text-secondary">
  {t("industries.title")} <span className="text-primary">{t("industries.titleHighlight")}</span>
  </h2>
  <p className="mt-4 text-muted-foreground max-w-2xl mx-auto text-lg">
 {t("industries.subtitle")}
 </p>
 </div>

 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
 {items.map((ind, i) => {
 const Icon = industryIcons[i];
 const color = colors[i];
 return (
   <div
 key={ind.title}
 className="relative bg-card rounded-xl p-5 text-center border border-border/60 hover:border-primary/40 shadow-[0_2px_16px_0_hsl(var(--primary)/0.07)] hover:shadow-[0_8px_32px_0_hsl(var(--primary)/0.13)] transition-all duration-500 group overflow-hidden" >
 <div className="absolute top-0 left-1/2 -translate-x-1/2 h-1 w-0 group-hover:w-full bg-primary transition-all duration-500 rounded-t-xl" />
 <div className="mx-auto w-12 h-12 rounded-xl bg-primary flex items-center justify-center mb-3 group-hover:scale-110 group-hover:rotate-3 transition-all duration-500 shadow-md">
 <Icon size={22} className="text-primary-foreground"/>
 </div>
  <h3 className="font-bold text-secondary text-[17px] mb-1">{ind.title}</h3>
  <p className="text-sm text-muted-foreground leading-relaxed">{ind.desc}</p>
  <div className="mt-3 opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0">
  <span className="text-primary text-sm font-medium">{t("industries.learnMore")}</span>
 </div>
 </div>
 );
 })}
 </div>
 </div>
 </section>
 );
}
